// Static shelf-life table for fresh produce & perishables.
// Values are approximate days in typical home storage.
// `room` = days at room temperature; `fridge` = refrigerated.
// `tips` is a short storage hint shown next to the item.

const SHELF_LIFE = {
  // Vegetables
  "tomato":        { room: 5,  fridge: 10, tips: "Counter ripe, fridge once cut" },
  "tomatoes":      { room: 5,  fridge: 10, tips: "Counter ripe, fridge once cut" },
  "lettuce":       { room: 1,  fridge: 7,  tips: "Wrap in paper, crisper drawer" },
  "spinach":       { room: 1,  fridge: 5,  tips: "Dry before storing" },
  "kale":          { room: 1,  fridge: 7,  tips: "Stem in water like flowers" },
  "broccoli":      { room: 2,  fridge: 7,  tips: "Loose in crisper" },
  "cauliflower":   { room: 2,  fridge: 7,  tips: "Stem-up, perforated bag" },
  "cabbage":       { room: 4,  fridge: 30, tips: "Lasts weeks whole in fridge" },
  "carrot":        { room: 4,  fridge: 21, tips: "Remove tops for longest life" },
  "carrots":       { room: 4,  fridge: 21, tips: "Remove tops for longest life" },
  "potato":        { room: 14, fridge: 0,  tips: "Cool & dark, NOT in fridge" },
  "potatoes":      { room: 14, fridge: 0,  tips: "Cool & dark, NOT in fridge" },
  "sweet potato":  { room: 21, fridge: 0,  tips: "Cool & dark, NOT in fridge" },
  "onion":         { room: 30, fridge: 0,  tips: "Dry & ventilated, away from potatoes" },
  "onions":        { room: 30, fridge: 0,  tips: "Dry & ventilated, away from potatoes" },
  "garlic":        { room: 30, fridge: 0,  tips: "Open-air, never fridge" },
  "ginger":        { room: 7,  fridge: 21, tips: "Fridge in airtight, or freeze" },
  "cucumber":      { room: 2,  fridge: 7,  tips: "Wrap loosely, crisper drawer" },
  "cucumbers":     { room: 2,  fridge: 7,  tips: "Wrap loosely, crisper drawer" },
  "bell pepper":   { room: 3,  fridge: 10, tips: "Crisper, eat before wrinkling" },
  "peppers":       { room: 3,  fridge: 10, tips: "Crisper, eat before wrinkling" },
  "capsicum":      { room: 3,  fridge: 10, tips: "Crisper, eat before wrinkling" },
  "chili":         { room: 5,  fridge: 14, tips: "Dry, refrigerate or freeze" },
  "celery":        { room: 2,  fridge: 14, tips: "Wrap in foil, lasts ages" },
  "mushroom":      { room: 2,  fridge: 7,  tips: "Paper bag, never plastic" },
  "mushrooms":     { room: 2,  fridge: 7,  tips: "Paper bag, never plastic" },
  "zucchini":      { room: 2,  fridge: 7,  tips: "Loose, no plastic" },
  "eggplant":      { room: 3,  fridge: 7,  tips: "Cool counter ideal" },
  "beans":         { room: 2,  fridge: 5,  tips: "Unwashed, perforated bag" },
  "peas":          { room: 1,  fridge: 4,  tips: "Refrigerate immediately" },
  "corn":          { room: 1,  fridge: 3,  tips: "Husks on, eat soonest" },
  "asparagus":     { room: 1,  fridge: 4,  tips: "Stems in shallow water" },
  "beetroot":      { room: 4,  fridge: 21, tips: "Trim tops, crisper" },
  "radish":        { room: 2,  fridge: 14, tips: "Crisper drawer" },

  // Fruits
  "apple":         { room: 5,  fridge: 30, tips: "Fridge keeps crunch for weeks" },
  "apples":        { room: 5,  fridge: 30, tips: "Fridge keeps crunch for weeks" },
  "banana":        { room: 5,  fridge: 0,  tips: "Counter; freeze when ripe" },
  "bananas":       { room: 5,  fridge: 0,  tips: "Counter; freeze when ripe" },
  "orange":        { room: 5,  fridge: 21, tips: "Fridge for longer storage" },
  "oranges":       { room: 5,  fridge: 21, tips: "Fridge for longer storage" },
  "lemon":         { room: 7,  fridge: 30, tips: "Fridge in jar of water" },
  "lemons":        { room: 7,  fridge: 30, tips: "Fridge in jar of water" },
  "lime":          { room: 5,  fridge: 21, tips: "Fridge stays plump" },
  "grape":         { room: 1,  fridge: 7,  tips: "Unwashed in fridge" },
  "grapes":        { room: 1,  fridge: 7,  tips: "Unwashed in fridge" },
  "strawberry":    { room: 1,  fridge: 5,  tips: "Don't wash until eating" },
  "strawberries":  { room: 1,  fridge: 5,  tips: "Don't wash until eating" },
  "blueberry":     { room: 1,  fridge: 10, tips: "Dry, vinegar wash extends life" },
  "blueberries":   { room: 1,  fridge: 10, tips: "Dry, vinegar wash extends life" },
  "raspberry":     { room: 1,  fridge: 3,  tips: "Eat fastest" },
  "raspberries":   { room: 1,  fridge: 3,  tips: "Eat fastest" },
  "mango":         { room: 5,  fridge: 7,  tips: "Counter to ripen, then fridge" },
  "pineapple":     { room: 3,  fridge: 7,  tips: "Fridge whole or cut" },
  "watermelon":    { room: 7,  fridge: 14, tips: "Counter whole, fridge cut" },
  "melon":         { room: 5,  fridge: 7,  tips: "Counter whole, fridge cut" },
  "peach":         { room: 3,  fridge: 5,  tips: "Counter to ripen" },
  "peaches":       { room: 3,  fridge: 5,  tips: "Counter to ripen" },
  "pear":          { room: 5,  fridge: 10, tips: "Counter to ripen" },
  "pears":         { room: 5,  fridge: 10, tips: "Counter to ripen" },
  "avocado":       { room: 4,  fridge: 7,  tips: "Fridge once ripe to pause" },
  "avocados":      { room: 4,  fridge: 7,  tips: "Fridge once ripe to pause" },
  "kiwi":          { room: 5,  fridge: 14, tips: "Counter to ripen" },

  // Herbs
  "basil":         { room: 4,  fridge: 0,  tips: "Counter, stems in water" },
  "cilantro":      { room: 1,  fridge: 7,  tips: "Stems in water, loose bag" },
  "coriander":     { room: 1,  fridge: 7,  tips: "Stems in water, loose bag" },
  "parsley":       { room: 1,  fridge: 14, tips: "Stems in water" },
  "mint":          { room: 2,  fridge: 7,  tips: "Damp paper, sealed" },
  "rosemary":      { room: 3,  fridge: 14, tips: "Wrap in damp paper" },
  "thyme":         { room: 3,  fridge: 14, tips: "Wrap in damp paper" },

  // Dairy / fresh
  "milk":          { room: 0,  fridge: 7,  tips: "Use within 7 days of opening" },
  "yogurt":        { room: 0,  fridge: 14, tips: "Best by date is conservative" },
  "cheese":        { room: 0,  fridge: 30, tips: "Wrap in wax paper" },
  "eggs":          { room: 0,  fridge: 30, tips: "Float test: fresh sinks" },
  "butter":        { room: 7,  fridge: 60, tips: "Salted lasts longer at room" },

  // Meat / fish
  "chicken":       { room: 0,  fridge: 2,  tips: "Freeze if not using in 2 days" },
  "beef":          { room: 0,  fridge: 4,  tips: "Vacuum-seal extends life" },
  "fish":          { room: 0,  fridge: 2,  tips: "Cook same day ideally" },
  "salmon":        { room: 0,  fridge: 2,  tips: "Cook same day ideally" },
  "shrimp":        { room: 0,  fridge: 2,  tips: "Keep on ice" },

  // Bakery
  "bread":         { room: 4,  fridge: 7,  tips: "Freeze sliced for weeks" },
  "loaf":          { room: 4,  fridge: 7,  tips: "Freeze sliced for weeks" },
};

const PERISHABLE_CATEGORIES = new Set(["Produce", "Dairy", "Meat", "Bakery", "Frozen"]);

function normalize(name) {
  return String(name || "").toLowerCase().trim().replace(/\s+/g, " ");
}

export function shelfLifeFor(name, category) {
  if (!PERISHABLE_CATEGORIES.has(category)) return null;
  const n = normalize(name);
  if (SHELF_LIFE[n]) return SHELF_LIFE[n];
  // Try matching by token (e.g. "ripe tomatoes" → "tomatoes")
  for (const token of n.split(" ")) {
    if (SHELF_LIFE[token]) return SHELF_LIFE[token];
  }
  // Fall back to softer category guesses
  if (category === "Produce") return { room: 3, fridge: 7,  tips: "Refrigerate to extend life" };
  if (category === "Dairy")   return { room: 0, fridge: 7,  tips: "Always refrigerate" };
  if (category === "Meat")    return { room: 0, fridge: 3,  tips: "Cook or freeze within 3 days" };
  if (category === "Bakery")  return { room: 3, fridge: 7,  tips: "Freeze for weeks" };
  if (category === "Frozen")  return { room: 0, fridge: 90, tips: "Use within 3 months frozen" };
  return null;
}

export function daysSince(iso) {
  if (!iso) return 0;
  try {
    const t = new Date(iso).getTime();
    return Math.max(0, Math.floor((Date.now() - t) / (24 * 3600 * 1000)));
  } catch { return 0; }
}

// Best-case days remaining (uses fridge value if available, else room).
export function daysRemaining(item) {
  const sl = shelfLifeFor(item.name, item.category);
  if (!sl) return null;
  const best = Math.max(sl.fridge, sl.room);
  const used = daysSince(item.updated_at || item.created_at);
  return { remaining: Math.max(0, best - used), best, used, info: sl };
}
